/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Ccc_VersionInputs */

const en_ccc_version = /** @type {(inputs: Ccc_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Closed Caption Creator v${i?.version}`)
};

const fr_ccc_version = /** @type {(inputs: Ccc_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Closed Caption Creator v${i?.version}`)
};

const de_ccc_version = /** @type {(inputs: Ccc_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Untertitel-Ersteller v${i?.version}`)
};

const it_ccc_version = /** @type {(inputs: Ccc_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Creatore di sottotitoli v${i?.version}`)
};

const ru_ccc_version = /** @type {(inputs: Ccc_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Создатель субтитров v${i?.version}`)
};

const es_ccc_version = /** @type {(inputs: Ccc_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Creador de subtítulos cerrados v${i?.version}`)
};

const zh_cn2_ccc_version = /** @type {(inputs: Ccc_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`隐藏式字幕创建器 v${i?.version}`)
};

const ja_ccc_version = /** @type {(inputs: Ccc_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`クローズドキャプションクリエイター v${i?.version}`)
};

const hi_ccc_version = /** @type {(inputs: Ccc_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्लोज्ड कैप्शन क्रिएटर v${i?.version}`)
};

const pt_pt2_ccc_version = /** @type {(inputs: Ccc_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Criador de legendas ocultas v${i?.version}`)
};

/**
* | output |
* | --- |
* | "Closed Caption Creator v{version}" |
*
* @param {Ccc_VersionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccc_version = /** @type {((inputs: Ccc_VersionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccc_VersionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccc_version(inputs)
	if (locale === "de") return de_ccc_version(inputs)
	if (locale === "it") return it_ccc_version(inputs)
	if (locale === "ru") return ru_ccc_version(inputs)
	if (locale === "es") return es_ccc_version(inputs)
	if (locale === "zh-CN") return zh_cn2_ccc_version(inputs)
	if (locale === "ja") return ja_ccc_version(inputs)
	if (locale === "hi") return hi_ccc_version(inputs)
	if (locale === "pt-PT") return pt_pt2_ccc_version(inputs)
	return en_ccc_version(inputs)
});